import { APP_BASE_HREF, AsyncPipe } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";

import { LayoutFacade } from "@hermes/aphrodite-layout-state";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { FooterItem } from "@hermes/api-model-shell";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";
import { type FooterColumnState } from "@hermes/domains-shell-states-shell-state";
import { TrayOpenerDirective } from "@hermes/hermes-web-states-tray-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";
import { stopEventPropagation } from "@hermes/utils-generic-helpers";
import { SanitizePipe } from "@hermes/utils-generic-pipes-sanitize";
import { RouterService } from "@hermes/utils-generic-services-router";
import { UserAgentPlatformService } from "@hermes/utils-generic-services-user-agent-platform";

import { FooterClickEvent } from "../../events/click.event";

import { PrefixWithPipe } from "./prefix-with.pipe";

@Component({
    selector: "h-footer-links-group-deprecated",
    imports: [
        SvgIconComponent,
        SrOnlyNoSnippetDirective,
        TrayOpenerDirective,
        AsyncPipe,
        SanitizePipe,
        PrefixWithPipe,
    ],
    templateUrl: "./footer-links-group-deprecated.component.html",
    styleUrls: ["./footer-links-group-deprecated.component.scss"],
})
export class FooterLinksGroupDeprecatedComponent {
    public baseHref = inject(APP_BASE_HREF);
    private readonly analyticsService = inject(AnalyticsService);
    private readonly routerService = inject(RouterService);
    public layoutFacade = inject(LayoutFacade);

    protected readonly isMobile = inject(UserAgentPlatformService)
        .isMobileSignal;

    @Input({ required: true })
    public column!: FooterColumnState;

    @Input({ required: true })
    public isLastColumn!: boolean;

    @Output()
    public triggerToggle = new EventEmitter<FooterColumnState>();

    /**
     * Emit an event with column data and let the parent drive the open/close of columns
     */
    public handleClickOnColumnLabel(): void {
        this.triggerToggle.emit(this.column);
    }

    /**
     * Send analytics in addition to existing behavior (redirect or open a tray)
     *
     * @param $event Click event
     * @param item Clicked item
     */
    public handleClickOnColumnItem($event: Event, item: FooterItem): void {
        this.analyticsService.sendData(
            new FooterClickEvent({
                action: this.column.label,
                label: item.label,
            }),
        );

        if (item.type === "internalLink") {
            stopEventPropagation($event);
            this.routerService.spaRedirect(item.data);
            return;
        }
        if (item.type === "externalLink") {
            stopEventPropagation($event);
            this.routerService.nativeRedirect(item.data);
            return;
        }

        $event.stopPropagation();
    }

    public goToContactUsPage(event: MouseEvent): void {
        event.preventDefault();
        this.routerService.spaRedirect("/contact-us/");
    }

    public cookieFooterEvent(event: Event): void {
        event.preventDefault();
        this.analyticsService.sendData(
            new FooterClickEvent({
                category: "Footer",
                action: "Legal",
                label: "open_legal_banner",
            }),
        );
    }
}
